import { render, staticRenderFns } from "./centreRight2Chart1.vue?vue&type=template&id=a4c39d4a&scoped=true&"
import script from "./centreRight2Chart1.vue?vue&type=script&lang=js&"
export * from "./centreRight2Chart1.vue?vue&type=script&lang=js&"
import style0 from "./centreRight2Chart1.vue?vue&type=style&index=0&id=a4c39d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c39d4a",
  null
  
)

export default component.exports